import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { FullPostType } from 'src/app/pages/starterDashboardV2/shared/components';

const PRE_MADE_POST_MODULE_CLICK_EVENT_NAME = 'petition_manage_ready_to_share_posts_click_v2_pre_drafted';

type UseClickTrackingParams = {
	selectedTab: string;
};

type UseClickTrackingResult = {
	trackClick: (fullPostType: FullPostType) => void;
};

export function useClickTracking({ selectedTab }: UseClickTrackingParams): UseClickTrackingResult {
	const track = useTracking();

	const trackClick = useCallback(
		(fullPostType: FullPostType) => {
			void track(PRE_MADE_POST_MODULE_CLICK_EVENT_NAME, {
				context: 'petition_dashboard_ready_to_share_post',
				view_context: selectedTab,
				location: fullPostType,
			});
		},
		[track, selectedTab],
	);

	return {
		trackClick,
	};
}
